import {getScrollAttemptedOffsetAfterPage} from './getScrollAttemptedOffsetAfterPage';

type ScrollAttemptedOffsetCache = {
  scrollAttemptedOffset?: number;
};

export function updateScrollAttemptedOffset(
  cache: ScrollAttemptedOffsetCache,
  page: number = 1
): void {
  const attemptedThroughOffset = getScrollAttemptedOffsetAfterPage(page);
  cache.scrollAttemptedOffset = Math.max(cache.scrollAttemptedOffset ?? 0, attemptedThroughOffset);
}
